import { MetricItem } from './MetricItem';

import * as S from './MetricsContent.styled';

export const MetricsContent = ({ data }) => {
  return (
    <S.Update>
      <MetricItem color={'217, 70, 239'} title='Installs' sum={data.installs.toFixed(0)} />
      <MetricItem color={'14, 165, 233'} title='Impressions' sum={data.impressions.toFixed(0)} />
      <MetricItem color={'139, 92, 246'} title='Clicks' sum={data.clicks.toFixed(0)} />
      <MetricItem color={'245, 158, 11'} title='Cost' sum={'$' + +data.cost.toFixed(2)} />
      <MetricItem color={'236, 72, 153'} title='Conversion Rate' sum={+data.cr.toFixed(2) + '%'} />
      <MetricItem color={'20, 184, 166'} title='Average CPI' sum={'$' + +data.avg_cpi.toFixed(2)} />
    </S.Update>
  );
};

MetricsContent.displayName = 'MetricsContent';
